import React from "react";
import PortableText from "../portableText";
import { cn, toPlainText } from "../../lib/helpers";
import { SectionHeaders } from "./wrapper";
import { ImageBuilder } from "../global/image-builder";
import { CardContext } from "../card/context";
import { Card } from "../card/card";
import { typesMap } from "./resources-list";

// @todo avoid overloading column and swtich them to FeaturedMedia section

const FeaturedMediaCard = ({ doc }) => {
  const isQuotable = doc._type === "quotable";

  return (
    <div className="mt-6 max-w-sm">
      <CardContext.Provider
        value={{
          ...doc,
          title: isQuotable ? false : doc.title,
          quote: isQuotable ? doc : doc.quote,
          hideImage: true,
          showSummary: !isQuotable,
          hideLabels: isQuotable,
          hideType: true,
          hideDate: true,
          cta: isQuotable ? null : typesMap.get(doc._type)?.cta || "Read more",
          isTall: true,
          skipLink: isQuotable,
        }}
      >
        <Card />
      </CardContext.Provider>
    </div>
  );
};

export const FeaturedMedia = ({ section }) => {
  const isLeft = section.layout === "left";
  const isCentered = section.layout === "centered";
  const isMediaSmall = section.layout === "mediaSmall";
  const isTwoUp = section.layout === "twoUp";
  const mainImage = section.image || section.mainImage;
  const featuredCard = section.contentRefs?.[0];

  return (
    <>
      <SectionHeaders header={section.header} layout={section.layout} />
      <div
        className={
          isCentered
            ? "text-center"
            : cn(
              "grid sm:grid-cols-2 gap-6 md:gap-12",
              isTwoUp
                ? "md:grid-cols-3/5-2/5 md:gap-20"
                : isLeft
                  ? "md:grid-cols-3/5-2/5"
                  : isMediaSmall
                    ? "md:grid-cols-2/3-1/3 gap-6 sm:gap-12 md:gap-24"
                    : "md:grid-cols-2/5-3/5"
            )
        }
      >
        {isCentered && section._rawSummary && (
          <div
            className={cn(
              "mx-auto",
              toPlainText(section._rawSummary).length > 200
                ? "max-w-screen-md"
                : "max-w-screen-sm"
            )}
          >
            <PortableText blocks={section._rawSummary} />
            {featuredCard && (
              <div className="flex justify-center">
                <FeaturedMediaCard doc={featuredCard} />
              </div>
            )}
          </div>
        )}
        <div
          className={cn(
            "rounded-xl overflow-hidden",
            isLeft
              ? ""
              : isTwoUp
                ? "order-2"
                : "sm:order-2 flex sm:justify-end",
            isMediaSmall ? "flex sm:justify-end items-start max-w-1/2 mx-auto sm:max-w-none sm:mx-0" : null,
            isCentered ? "py-8 lg:pb-12 flex justify-center" : null,
            section.background === "gradientSpotlightsSpiral" ? "mr-8" : null
          )}
        >
          <div className="relative">
            {mainImage && (
              <>
                {mainImage ? (
                  mainImage?.link ? (
                    <a href={mainImage.link} target="_blank">
                      <ImageBuilder
                        image={mainImage}
                        alt={mainImage.alt}
                        width={isCentered ? 1024 : isMediaSmall ? 473 : 606}
                        className="transform transition-card scale-100 hover:scale-110"
                      />
                    </a>
                  ) : (
                    <ImageBuilder
                      image={mainImage}
                      alt={mainImage.alt}
                      width={isCentered ? 1024 : isMediaSmall ? 473 : 606}
                    />
                  )
                ) : null}
                {mainImage.caption && (
                  <figcaption className="text-secondary text-center text-sm mt-4 mb-6">
                    {mainImage.caption}
                  </figcaption>
                )}
              </>
            )}
            {isTwoUp && (
              <div className="hidden md:flex items-start absolute top-0 left-0 bottom-0 right-0">
                <ImageBuilder
                  src="/static/img/icons/long-arrow-right.svg"
                  className="relative -ml-14"
                />
              </div>
            )}
          </div>
        </div>

        {!isCentered && section._rawSummary && (
          <div
            className={cn(
              "flex flex-wrap sm:content-center items-center sm:h-full leading-tight",
              isLeft ? "sm:order-2" : isTwoUp ? "order-1" : "sm:order-1"
            )}
          >
            <div className="w-full">
              <PortableText blocks={section._rawSummary} />
              {featuredCard && <FeaturedMediaCard doc={featuredCard} />}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export const Image = ImageBuilder;
